<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧社区</h2>
        <h3>建行微应用人脸识别通道管理系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <div>
          <h2>建行微应用人脸识别通道管理系统</h2>
          <p>建行微应用人脸识别通道管理系统系统社区人员与访客通过人脸识别 通道，通过刷脸开闸门进出社区，同时社区家长手机应用端即时接收到孩子 到离家的信息提示。学校采用建行微应用人脸识别通道管理系统，其目的是 有效地控制人员的出入，并且记录所有出入的详细情况，来实现出入口的方 便快捷、安全高效管理由电子标和或人脸识别。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScfaceRecognition',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
